import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { Check, Shield, Crown, BookOpen, Zap, CreditCard, Star, ArrowRight } from 'lucide-react';
type Tier = 'elite' | 'pro';
export function OfferSection() {
  const [selected, setSelected] = useState<Tier>('pro');
  const includes = ['Tomo 1: Yoga para dormir mejor', 'Tomo 2: Yoga anti ansiedad infantil', 'Tomo 3: Yoga y concentración', 'Tomo 4: Yoga divertido con animales', 'Tomo 5: Rutinas rápidas de 5 min', 'Tomo 6: Mindfulness y respiración', 'BONUS: 6 Regalos Exclusivos', 'Acceso de por vida al material', 'Actualizaciones gratuitas'];
  return <section id="oferta" className="py-20 bg-pastel-white" data-id="element-166">
      <div className="container mx-auto px-5 sm:px-8 lg:px-12" data-id="element-167">
        {/* Pricing card */}
        <div className="max-w-2xl mx-auto bg-white rounded-[2rem] shadow-2xl shadow-pastel-lavender/20 border border-pastel-lavender/20 p-6 sm:p-10" data-id="element-168">
          {/* Header */}
          <div className="text-center mb-8" data-id="element-169">
            <h2 className="text-2xl sm:text-4xl font-display font-bold text-gray-900 mb-2" data-id="element-170">
              Elegí tu{' '}
              <span className="text-gradient from-pastel-lavender-dark to-pastel-pink" data-id="element-171">
                YOGA KIDS ELITE
              </span>
            </h2>
            <p className="text-sm sm:text-base text-gray-500" data-id="element-172">
              Ambas opciones incluyen los 6 bonos exclusivos
            </p>
          </div>

          {/* Option rows */}
          <div className="space-y-4 mb-6" data-id="element-173">
            {/* ELITE option */}
            <motion.button type="button" onClick={() => setSelected('elite')} whileTap={{
            scale: 0.99
          }} className={`w-full text-left rounded-2xl border-2 p-5 sm:p-6 transition-all duration-300 ${selected === 'elite' ? 'border-pastel-lavender-dark bg-pastel-lavender/10 shadow-md' : 'border-gray-200 bg-white hover:border-gray-300'}`} data-id="element-174">
              <div className="flex items-center gap-3 sm:gap-4" data-id="element-175">
                {/* Radio */}
                <div className={`shrink-0 w-5 h-5 sm:w-6 sm:h-6 rounded-full border-2 flex items-center justify-center transition-colors ${selected === 'elite' ? 'border-pastel-lavender-dark' : 'border-gray-300'}`} data-id="element-176">
                  {selected === 'elite' && <div className="w-2.5 h-2.5 sm:w-3 sm:h-3 rounded-full bg-pastel-lavender-dark" data-id="element-177" />}
                </div>

                {/* Info */}
                <div className="flex-1 min-w-0" data-id="element-178">
                  <div className="flex items-center gap-2 mb-1" data-id="element-179">
                    <BookOpen size={16} className="text-pastel-aqua shrink-0" data-id="element-180" />
                    <span className="font-display font-bold text-gray-900 text-base sm:text-lg uppercase tracking-wide" data-id="element-181">
                      Yoga Kids ELITE
                    </span>
                  </div>
                  <p className="text-xs sm:text-sm text-gray-500" data-id="element-182">
                    6 tomos + 6 bonos exclusivos
                  </p>
                </div>

                {/* Price */}
                <div className="text-right shrink-0" data-id="element-183">
                  <div className="text-xs sm:text-sm text-gray-400 line-through" data-id="element-184">
                    $34.990
                  </div>
                  <div className="text-xl sm:text-2xl font-display font-bold text-gray-900" data-id="element-185">
                    $19.990
                  </div>
                </div>
              </div>
            </motion.button>

            {/* PRO / Pack Completo option */}
            <motion.button type="button" onClick={() => setSelected('pro')} whileTap={{
            scale: 0.99
          }} className={`relative w-full text-left rounded-2xl border-2 p-5 sm:p-6 transition-all duration-300 ${selected === 'pro' ? 'border-pastel-lavender-dark bg-gradient-to-br from-pastel-lavender/15 to-pastel-pink/10 shadow-[0_0_30px_-5px_rgba(167,139,250,0.5)]' : 'border-gray-200 bg-white hover:border-gray-300'}`} data-id="element-186">
              <div className="flex items-start gap-3 sm:gap-4" data-id="element-187">
                {/* Radio */}
                <div className={`mt-1 shrink-0 w-5 h-5 sm:w-6 sm:h-6 rounded-full border-2 flex items-center justify-center transition-colors ${selected === 'pro' ? 'border-pastel-lavender-dark' : 'border-gray-300'}`} data-id="element-188">
                  {selected === 'pro' && <div className="w-2.5 h-2.5 sm:w-3 sm:h-3 rounded-full bg-pastel-lavender-dark" data-id="element-189" />}
                </div>

                {/* Info */}
                <div className="flex-1 min-w-0" data-id="element-190">
                  <div className="flex items-center gap-2 mb-2" data-id="element-191">
                    <Crown size={16} className="text-pastel-yellow shrink-0" fill="currentColor" data-id="element-192" />
                    <span className="font-display font-bold text-gray-900 text-base sm:text-lg uppercase tracking-wide" data-id="element-193">
                      Pack Completo
                    </span>
                  </div>

                  {/* Badges */}
                  <div className="flex flex-wrap gap-2 mb-2" data-id="element-194">
                    <span className="inline-flex items-center gap-1 px-2.5 py-1 rounded-md bg-pastel-yellow text-amber-900 text-[10px] sm:text-xs font-bold uppercase tracking-wider" data-id="element-195">
                      <Star size={11} fill="currentColor" data-id="element-196" />
                      Más elegido
                    </span>
                    <span className="inline-block px-2.5 py-1 rounded-md bg-emerald-100 text-emerald-700 text-[10px] sm:text-xs font-bold uppercase tracking-wider" data-id="element-197">
                      Ahorrás $22.000
                    </span>
                  </div>

                  <p className="text-xs sm:text-sm text-gray-600" data-id="element-198">
                    6 tomos + 6 bonos +{' '}
                    <span className="font-bold text-pastel-lavender-dark" data-id="element-199">
                      PRO ELITE™
                    </span>
                  </p>
                </div>

                {/* Price */}
                <div className="text-right shrink-0" data-id="element-200">
                  <div className="text-xs sm:text-sm text-gray-400 line-through" data-id="element-201">
                    $49.990
                  </div>
                  <div className="text-xl sm:text-2xl font-display font-bold text-pastel-lavender-dark drop-shadow-sm" data-id="element-202">
                    $27.990
                  </div>
                </div>
              </div>
            </motion.button>
          </div>

          {/* Dynamic CTA */}
          <motion.button whileHover={{
          scale: 1.01
        }} whileTap={{
          scale: 0.98
        }} className="w-full bg-gradient-to-r from-pastel-lavender-dark to-pastel-pink text-white font-display font-bold text-base sm:text-lg uppercase tracking-wider rounded-2xl py-4 sm:py-5 shadow-lg shadow-pastel-lavender-dark/30 hover:shadow-xl hover:shadow-pastel-lavender-dark/40 transition-shadow flex items-center justify-center gap-2" data-id="element-203">
            {selected === 'pro' ? 'SÍ, QUIERO PACK COMPLETO' : 'SÍ, QUIERO YOGA KIDS ELITE'}
            <ArrowRight size={20} data-id="element-204" />
          </motion.button>

          <p className="text-center text-xs sm:text-sm text-gray-500 italic mt-4 mb-6" data-id="element-205">
            {selected === 'pro' ? 'La opción más elegida por familias que buscan el máximo resultado' : 'El kit esencial para empezar a transformar la rutina de tus hijos'}
          </p>

          {/* Trust footer */}
          <div className="pt-5 border-t border-gray-100 flex flex-wrap items-center justify-center gap-x-5 gap-y-2 text-xs sm:text-sm text-gray-600 font-medium" data-id="element-206">
            <div className="flex items-center gap-1.5" data-id="element-207">
              <Shield size={15} className="text-pastel-pink" data-id="element-208" />
              <span data-id="element-209">Pago seguro</span>
            </div>
            <div className="flex items-center gap-1.5" data-id="element-210">
              <Zap size={15} className="text-pastel-yellow" data-id="element-211" />
              <span data-id="element-212">Acceso en 5 min</span>
            </div>
            <div className="flex items-center gap-1.5" data-id="element-213">
              <Check size={15} className="text-pastel-mint" strokeWidth={3} data-id="element-214" />
              <span data-id="element-215">Garantía 7 días</span>
            </div>
            <div className="flex items-center gap-1.5" data-id="element-216">
              <CreditCard size={15} className="text-pastel-aqua" data-id="element-217" />
              <span data-id="element-218">Astropay</span>
            </div>
          </div>
        </div>

        {/* INCLUDES SUMMARY CARD */}
        <div className="max-w-4xl mx-auto bg-white rounded-[2.5rem] shadow-xl overflow-hidden border border-gray-100 mt-12" data-id="element-219">
          <div className="bg-gradient-to-r from-pastel-lavender-dark to-pastel-pink p-6 text-center text-white" data-id="element-220">
            <h2 className="text-2xl md:text-3xl font-display font-bold" data-id="element-221">
              Todo lo que recibís hoy
            </h2>
          </div>

          <div className="p-8 md:p-10" data-id="element-222">
            <ul className="grid grid-cols-1 sm:grid-cols-2 gap-x-8 gap-y-3" data-id="element-223">
              {includes.map((item, index) => <li key={index} className="flex items-start gap-3" data-id="element-224">
                  <div className="mt-1 bg-pastel-mint/30 text-emerald-600 rounded-full p-1 shrink-0" data-id="element-225">
                    <Check size={16} strokeWidth={3} data-id="element-226" />
                  </div>
                  <span className={index === 6 ? 'font-bold text-amber-600' : 'text-gray-700'} data-id="element-227">
                    {item}
                  </span>
                </li>)}
            </ul>

            <div className="mt-8 pt-6 border-t border-gray-100 text-center text-sm text-gray-500 space-y-2" data-id="element-228">
              <p data-id="element-229">Astropay · Tarjeta · Transferencia</p>
              <div className="flex items-center justify-center gap-1 text-emerald-600 font-medium" data-id="element-230">
                <Shield size={16} data-id="element-231" />
                <span data-id="element-232">Garantía de satisfacción de 7 días</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}